import { Typography } from "@mui/material";

export default function Title(props) {
  return (
    <Typography variant="h3" gutterBottom component="div" color='secondary'>
      {props.title}
    </Typography>
  )
}